import {ReactNode} from "react";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";

export abstract class SlateMarkBase {
    public GetMark(editor: SlateEditor): ReactNode {
        return null;
    }


    public abstract RenderMark(mark, children, attributes): ReactNode;
    public abstract Serialize(el:HTMLElement,next:any);
}
